var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leading Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.4 20C3.903 20 2.6288 19.5042 1.5774 18.5126C0.5258 17.5211 0 16.3092 0 14.8769C0 13.5231 0.4892 12.3495 1.4676 11.356C2.4462 10.3627 3.5955 9.82857 4.9155 9.75371C5.1847 8.08933 5.9885 6.71429 7.3269 5.62857C8.6653 4.54286 10.223 4 12 4C14.0058 4 15.7072 4.66533 17.1042 5.996C18.5014 7.32648 19.2 8.94686 19.2 10.8571V12H19.9386C21.0878 12.0352 22.052 12.437 22.8312 13.2054C23.6104 13.974 24 14.9055 24 16C24 17.121 23.6019 18.0678 22.8057 18.8406C22.0095 19.6135 21.023 20 19.8462 20H13.3386C12.7862 20 12.325 19.8238 11.955 19.4714C11.585 19.119 11.4 18.6798 11.4 18.1537V11.5209L8.88 13.9077L8.0307 13.1209L12 9.34057L15.9693 13.1209L15.12 13.9077L12.6 11.5209V18.1537C12.6 18.3297 12.6769 18.491 12.8307 18.6374C12.9845 18.7839 13.1538 18.8571 13.3386 18.8571H19.8C20.64 18.8571 21.35 18.581 21.93 18.0286C22.51 17.4762 22.8 16.8 22.8 16C22.8 15.2 22.51 14.5238 21.93 13.9714C21.35 13.419 20.64 13.1429 19.8 13.1429H18V10.8571C18 9.27619 17.415 7.92857 16.245 6.81429C15.075 5.7 13.66 5.14286 12 5.14286C10.34 5.14286 8.925 5.7 7.755 6.81429C6.585 7.92857 6 9.27619 6 10.8571H5.3538C4.24 10.8571 3.2692 11.2476 2.4414 12.0286C1.6138 12.8095 1.2 13.7524 1.2 14.8571C1.2 15.9619 1.61 16.9048 2.43 17.6857C3.25 18.4667 4.24 18.8571 5.4 18.8571H8.4V20H5.4Z",
    fill: "#3749AD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.25325f44aeb136b6aacc35fcd94daf6b.svg";
export { ForwardRef as ReactComponent };